export { wrapRootElement } from '@greythr/shared-store/wrapper';
import "@fontsource/open-sans";
import "@fontsource/open-sans/500.css";
import "@fontsource/open-sans/600.css";
import "@fontsource/open-sans/700.css";
import "@fontsource/poppins";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";

export const onRouteUpdate = () => {
  if (window) {
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'optimize.activate' });
    }
    //Below lines are for AC site tracking.
    if (window.vgo) {
      window.vgo('update');
    }

    //Below lines of codes are for calling generic gatsby route changed event handler which is inserted to SPA 
    //Through GTM tag "Gatsby Route Changed Event Handler".
    if (window.gatsbyRouteChangedEventHandler) {
      window.gatsbyRouteChangedEventHandler();
    }
    
  }
};

// The below lines of code is for persisting any params added in URL across the site navigation.
// This is done to ensure that the params are available in the URL for capturing and sending on form submissions for tracking purposes.
let persistentParams = {};

const getInitialParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const params = {};

  for (const [key, value] of urlParams.entries()) {
    params[key] = value;
  }

  if (Object.keys(params).length === 0) {
    const storedParams = JSON.parse(sessionStorage.getItem("persistent_params") || "{}");
    return storedParams;
  }

  return params;
};

const saveParamsToSession = (params) => {
  sessionStorage.setItem("persistent_params", JSON.stringify(params));
};

const injectParamsIntoUrl = (url) => {
  if (!persistentParams || Object.keys(persistentParams).length === 0) return url;

  let tempUrl;
  try {
    tempUrl = /^https?:\/\//i.test(url)
      ? new URL(url)
      : new URL(url, window.location.origin);
  } catch (e) {
    console.error("Invalid URL:", url, e);
    return url;
  }

  for (const key in persistentParams) {
    tempUrl.searchParams.set(key, persistentParams[key]);
  }

  return tempUrl.toString();
};

const patchHistoryMethod = (type) => {
  const original = history[type];
  history[type] = function (...args) {
    if (typeof args[2] === "string") {
      args[2] = injectParamsIntoUrl(args[2]);
    }
    return original.apply(this, args);
  };
};

const patchLinkClicks = () => {
  document.addEventListener("click", (e) => {
    const anchor = e.target.closest('a[href]');
    if (!anchor || !document.contains(anchor)) return;

    const href = anchor.getAttribute("href");
    if (!href || href.startsWith("#") || href.startsWith("javascript:")) return;

    if (href.startsWith("http") || href.startsWith("/")) {
      const modifiedHref = injectParamsIntoUrl(href);
      anchor.href = modifiedHref;
    }
  });
};

const patchWindowOpen = () => {
  const originalWindowOpen = window.open;
  window.open = function (url, target, features) {
    if (typeof url === "string" && (target === "_blank" || !target)) {
      const newUrl = injectParamsIntoUrl(url);
      return originalWindowOpen.call(window, newUrl, target, features);
    }
    return originalWindowOpen.apply(window, arguments);
  };
};

export const onInitialClientRender = () => {
  persistentParams = getInitialParams();
  saveParamsToSession(persistentParams);

  patchHistoryMethod("pushState");
  patchHistoryMethod("replaceState");
  patchLinkClicks();
  patchWindowOpen();

  window.addEventListener("popstate", () => {
    persistentParams = getInitialParams();
    saveParamsToSession(persistentParams);
  });

  const url = new URL(window.location.href);
  let needsUpdate = false;

  for (const key in persistentParams) {
    if (!url.searchParams.has(key)) {
      url.searchParams.set(key, persistentParams[key]);
      needsUpdate = true;
    }
  }

  if (needsUpdate) {
    window.history.replaceState({}, "", url.pathname + url.search);
  }
};
